import { render, staticRenderFns } from "./PreEntregas.vue?vue&type=template&id=2269b1ba&scoped=true"
import script from "./PreEntregas.vue?vue&type=script&lang=js"
export * from "./PreEntregas.vue?vue&type=script&lang=js"
import style0 from "./PreEntregas.vue?vue&type=style&index=0&id=2269b1ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2269b1ba",
  null
  
)

export default component.exports